// extracted by mini-css-extract-plugin
export default {"tabbar":"navbar_tabbar__8kiKm"};